/* @flow */
import {configure} from './configure';

export type {NutshellSharedState} from './types';

export const Store = {
    configure,
};
